// Tracks, for the current browser session (until a full page reload), which tables have had
// an external import running at any point. Once a sync has started we keep treating the
// table as "syncing" for row-adding purposes even after it completes: the freshly imported
// rows only appear once the user reloads, and adding rows to a table that is (about to be)
// synced isn't allowed. A hard refresh recreates this module state, by which point the table
// loads as synced anyway — so the row-adding controls stay hidden either way.

const tablesSyncedThisSession = new Set<string>()

export const markSyncStartedThisSession = (tableId: string): void => {
  if (tableId) {
    tablesSyncedThisSession.add(tableId)
  }
}

export const hasSyncStartedThisSession = (tableId: string): boolean => tablesSyncedThisSession.has(tableId)
